import React from 'react'
import PropTypes from 'prop-types'
import styles from './Subnavigation.module.scss'
import {
  BaseComponent,
} from 'belle-js'
import Link from 'redux-first-router-link'
import classnames from 'classnames'
import { trackAnalyticsEvent } from 'analytics'

class Subnavigation extends BaseComponent {

  constructor (props) {
    super(props)

    this.state = {
      openMenu: false
    }

    this.bind('handleItemChange', 'handleToggleMobileMenu')
  }

  handleItemChange (tab) {
    const {
      onItemSelected
    } = this.props

    trackAnalyticsEvent(`${tab} clicked`)
    this.setState({ openMenu: false })
    this.addBodyOverflow(true)
    onItemSelected(tab)
  }

  handleToggleMobileMenu () {
    const { openMenu } = this.state

    this.addBodyOverflow(openMenu)
    this.setState(prevState => ({
      openMenu: !prevState.openMenu
    }))
  }

  addBodyOverflow (addOverflow) {
    document.body.setAttribute('style', `overflow: ${!addOverflow ? 'hidden' : ''}`)
  }

  renderTabsMenu () {
    const {
      children,
      activeTab,
    } = this.props

    return React.Children.toArray(children)
      .filter(child => !!child.props.label)
      .map((child) => {
        const { label } = child.props
        return React.cloneElement(child, {
          key: label,
          activeTab,
          onClick: this.handleItemChange
        })
      })
  }


  renderButtons () {
    const { children } = this.props
    const buttons = children.filter(child => child &&
      !!child.props.highlightButton && child.props.display)
    const buttonClasses = classnames('button button--primary', styles.highlightLink)

    return (buttons.map((button) => {
      const { props: { route, text, buttonText } } = button
      return (
        <div key={route} className={styles.highlightButton} data-test-id="highlightButton">
          <hr />
          <p className={styles.highlightLinkText}>{text}</p>
          <Link
            key={route}
            className={buttonClasses}
            to={route}
            onClick={() => trackAnalyticsEvent(`${buttonText} Clicked`)}>
            {buttonText}
          </Link>
        </div>
      )
    }))
  }

  renderDesktopButtons () {
    return (
      <div className={styles.desktopHighlightButtons}>
        {this.renderButtons()}
      </div>
    )
  }

  renderMobileMenu () {
    const {
      activeTab
    } = this.props

    return (
      <React.Fragment>
        <div className={styles.activeTab}>
          {this.state.openMenu ? 'Menu' : activeTab}
        </div>
        { !this.state.openMenu &&
          <button
            data-test-id="subnavigationMenuButton"
            className={styles.menuButton}
            type="button"
            onClick={this.handleToggleMobileMenu}>
              Menu
          </button>
        }
        {this.state.openMenu &&
          <div>
            <div className={styles.buttonContainer}>
              <div className={styles.activeTab}>
                {this.state.openMenu ? 'Menu' : activeTab}
              </div>
              <button
                data-test-id="subnavigationCloseButton"
                className={styles.closeButton}
                type="button"
                onClick={this.handleToggleMobileMenu}>
              close
              </button>
            </div>

            <div className={styles.menuContainer}>
              <ul className={styles.actions}>
                {this.renderTabsMenu()}
              </ul>
              {this.renderButtons()}
            </div>
          </div>
        }
      </React.Fragment>
    )
  }

  renderDesktopMenu () {
    return (
      <ul className={styles.actions}>
        {this.renderTabsMenu()}
      </ul>
    )
  }


  getTabContent (children, activeTab) {
    return children.filter(c => !!c).map((child) => {
      const isChildFragment = child.type.toString() === React.Fragment.toString()
      const isChildDropdown = child.props.isDropdown
      if (!isChildDropdown && !isChildFragment) {
        if (child.props.label === activeTab) return child.props.children
        return undefined
      } else {
        return this.getTabContent(child.props.children, activeTab)
      }
    })
  }

  renderContentSection () {
    const { children, activeTab } = this.props
    return this.getTabContent(children, activeTab)
  }

  render () {
    return (
      <React.Fragment>
        <div className={styles.container}>
          <div className={styles.desktopView}>
            {this.renderDesktopMenu()}
          </div>
          <div className={styles.mobileView}>
            {this.renderMobileMenu()}
          </div>
        </div>
        {this.renderDesktopButtons()}
        <div className={styles.itemContent}>
          {this.renderContentSection()}
        </div>
      </React.Fragment>
    )
  }

}

Subnavigation.defaultProps = {
  onItemSelected: () => {},
  optionSelected: null,
}

Subnavigation.propTypes = {
  activeTab: PropTypes.string.isRequired,
  onItemSelected: PropTypes.func,
  children: PropTypes.node.isRequired,
  optionSelected: PropTypes.oneOf([
    'shared',
    'statements',
    'login',
    'personal'
  ]),
}

export default Subnavigation



// WEBPACK FOOTER //
// ./src/components/Client/Subnavigation/Subnavigation.js